import { CONTAINER_NAME } from "../_utils/constant";
import { normalize } from "../common";
var vibrateLong = normalize(function (_ref) {
  var fail = _ref.fail,
      complete = _ref.complete;
  fail && fail('@uni：vibrateLong 快手小程序暂不支持');
  complete && complete('@uni：vibrateLong 快手小程序暂不支持');
}, CONTAINER_NAME.KWAI);
export default vibrateLong;